// extracted by mini-css-extract-plugin
export default {"icon":"StatusPills_icon__MzKgr","text":"StatusPills_text__uezjL"};